import { render, staticRenderFns } from "./Lives.vue?vue&type=template&id=dc5cf030&"
import script from "./Lives.vue?vue&type=script&lang=js&"
export * from "./Lives.vue?vue&type=script&lang=js&"
import style0 from "./Lives.vue?vue&type=style&index=0&id=dc5cf030&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports